<script lang="ts">
  interface Props {
    checked: boolean
    disabled?: boolean
    label: string
    onchange: (checked: boolean) => void
  }
  const { checked, disabled = false, label, onchange }: Props = $props()
</script>

<label class="wrap" class:disabled>
  <input
    type="checkbox"
    {checked}
    {disabled}
    aria-label={label}
    onchange={(event) => onchange(event.currentTarget.checked)}
  />
  <span class="box" aria-hidden="true">
    <svg viewBox="0 0 24 24" width="16" height="16">
      <path
        d="M20 6 9 17l-5-5"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </span>
</label>

<style>
  .wrap {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    flex: 0 0 44px;
    cursor: pointer;
  }
  .wrap.disabled {
    cursor: default;
  }
  input {
    position: absolute;
    width: 1px;
    height: 1px;
    opacity: 0;
  }
  .box {
    display: grid;
    place-items: center;
    width: 22px;
    height: 22px;
    border: 2px solid var(--border-strong);
    border-radius: 7px;
    background: var(--surface);
    color: var(--accent-fg);
    transition:
      background var(--dur-fast) var(--ease),
      border-color var(--dur-fast) var(--ease);
  }
  .wrap:hover:not(.disabled) .box {
    border-color: var(--accent);
  }
  input:focus-visible + .box {
    outline: 2px solid var(--accent);
    outline-offset: 2px;
  }
  svg path {
    stroke-dasharray: 24;
    stroke-dashoffset: 24;
    transition: stroke-dashoffset var(--dur-fast) var(--ease);
  }
  input:checked + .box {
    background: var(--accent);
    border-color: var(--accent);
  }
  input:checked + .box path {
    stroke-dashoffset: 0;
  }
  .wrap.disabled .box {
    opacity: 0.6;
  }
</style>
